import React, { useState } from 'react';
import './App.css';
import Chat from './chat';
import './chat.css';
import Profile from './profileabt';
import Upload from './upload';
import './upload.css';
import Tweet from './tweet.js';
import{Routes,Route, BrowserRouter} from'react-router-dom';
import UserProfile from './user_profile';
import Retweet from './retweet.js'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Login from './login.js';
import Register from './reg.js';
function App() {
const [showPopup,setShowPopup]=useState(false);
const [currentUser, setCurrentUser] = useState(null);
  return(
    <BrowserRouter>
            <ToastContainer position='top-right'/>
    <Routes>
        <Route path='/'element={<Register/>}/>
       <Route path='/chat'element={<Chat openPopup={()=>setShowPopup(true)} setCurrentUser={setCurrentUser}/>}/>
        <Route path='/profileabt'element={<Profile/>}/>
        <Route path='/upload'element={<Upload/>}/>
        <Route path='/user_profile'element={<UserProfile openPopup={()=>setShowPopup(true)}/>}/>
        <Route path='/tweet'element={<Tweet/>}/>
        <Route path='/login'element={<Login setCurrentUser={setCurrentUser}/>}/>
        <Route path='/retweet'element={<Retweet openPopup={()=>setShowPopup(true)}/>}/>
    </Routes>
    {showPopup && (
      <>
      <div className='lay' onClick={()=>setShowPopup(false)}></div>
      <Tweet closePopup={()=>setShowPopup(false)}/>

        <div className='Lay' onClick={()=>setShowPopup(false)}></div>
      <Retweet closePopup={()=>setShowPopup(false)}/>
      </>
    )}
    </BrowserRouter>
  );
}

export default App;
         